import type { RedemptionModalOrderData, Survey } from '@shared/dream-components';
import { FreeProductCheckoutModalElement } from '@shared/dream-components/src';

import type useGDPRTranslations from '~/components/DreamBuilder/nodes/hooks/useGDPRTranslations';
import SignupAction from '~/components/SignupAction';
import type { ToastData } from '~/hooks/useToast';
import type { RootLoaderData } from '~/root';

import type useFreeProductCheckoutModalTranslations from '../_hooks/useFreeProductCheckoutModalTranslations';
import { MODAL_ELEMENT_ATTRS } from './constants';

export interface GuestCheckoutModalProps {
  productVariantId: string;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (data: { order?: RedemptionModalOrderData; toast?: ToastData }) => void;
  site: RootLoaderData['site'];
  gdprTranslations: ReturnType<typeof useGDPRTranslations>;
  translations: ReturnType<typeof useFreeProductCheckoutModalTranslations>;
  form?: Survey;
}

const GuestCheckoutModal = ({
  productVariantId,
  isOpen,
  onClose,
  onSuccess,
  site,
  gdprTranslations,
  translations,
  form,
}: GuestCheckoutModalProps) => {
  return (
    <SignupAction
      id={'free-product-guest-checkout-modal'}
      onSuccess={onSuccess}
      shouldSkipRedirectsAfterSuccess
      shouldSkipAutoLogIn
    >
      {({ isLoading, setEmail }) => (
        <>
          <input type="hidden" name="product_variant_id" value={productVariantId} />
          {form && <input type="hidden" name="form_id" value={form.id} />}
          <FreeProductCheckoutModalElement
            element={{
              type: 'freeProductCheckoutModal',
              attrs: MODAL_ELEMENT_ATTRS,
              content: [{ id: '', text: '' }],
            }}
            isOpen={isOpen}
            onOpenChange={onClose}
            isLoading={isLoading}
            translations={translations}
            gdprTranslations={gdprTranslations}
            hasTermsOfService={site.viewable_site_version.settings.terms_of_service_enabled}
            hasCustomTermsOfService={site.viewable_site_version.settings.terms_of_service}
            customTermsOfServiceText={site.viewable_site_version.settings.terms_of_service_text || undefined}
            defaultTOSConsentValue={false}
            onEmailChange={setEmail}
            isPreviewing={false}
            form={form}
          >
            {null}
          </FreeProductCheckoutModalElement>
        </>
      )}
    </SignupAction>
  );
};

export default GuestCheckoutModal;
